import { render, staticRenderFns } from "./advancepayments.vue?vue&type=template&id=59f68874&scoped=true"
import script from "./advancepayments.vue?vue&type=script&lang=js"
export * from "./advancepayments.vue?vue&type=script&lang=js"
import style0 from "./advancepayments.vue?vue&type=style&index=0&id=59f68874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f68874",
  null
  
)

export default component.exports